import React from 'react';

// Back side of a feed card: what the tea is, how to brew it, how it feels.
// Facts come from the API (category_product, tea_info); sections are skipped when the data is missing.
export default function ProductInfoContent({ product }) {
  const info = product.tea_info || {};
  const teaType = product.category_product?.name;
  const temperature = info.brew_temperature;
  const effects = Array.isArray(info.states) ? info.states : [];
  const flavors = Array.isArray(info.flavors) ? info.flavors : [];

  const paragraphs = (product.description || '')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <div className="products__info-content">
      <h2 className="products__info-title">{product.title}</h2>

      {(teaType || temperature) && (
        <div className="products__info-facts">
          {teaType && (
            <div className="products__info-fact">
              <span className="products__info-label">Тип чаю</span>
              <span className="products__info-fact-value">{teaType}</span>
            </div>
          )}
          {temperature && (
            <div className="products__info-fact">
              <span className="products__info-label">Температура</span>
              <span className="products__info-fact-value">{temperature}</span>
            </div>
          )}
        </div>
      )}

      {effects.length > 0 && (
        <div className="products__info-group">
          <span className="products__info-label">Ефект</span>
          <div className="products__info-tags">
            {effects.map((effect) => (
              <span key={effect} className="products__info-pill">{effect}</span>
            ))}
          </div>
        </div>
      )}

      {flavors.length > 0 && (
        <div className="products__info-group">
          <span className="products__info-label">Смаки</span>
          <div className="products__info-tags">
            {flavors.map((flavor) => (
              <span key={flavor} className="products__info-pill products__info-pill--light">{flavor}</span>
            ))}
          </div>
        </div>
      )}

      <div className="products__info-description">
        {paragraphs.length > 0
          ? paragraphs.map((line, i) => <p key={i}>{line}</p>)
          : <p>Опис відсутній</p>}
      </div>
    </div>
  );
}
